import { useContext } from 'react'

import AuthContext from '@contexts/Auth/AuthContext'

import { REVENUE_AGENTS_EMAILS } from '../constants/emailsList'

/** @public */
export const useRevenueAgentsPermission = () => {
  const auth = useContext(AuthContext)
  const user = auth.user

  return !!user?.email && REVENUE_AGENTS_EMAILS.includes(user?.email)
}
